import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VisibilityContextService {
  enabled = true;

  constructor() {}

  isEnabled(): boolean {
    return this.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }
}
